export default "__VITE_ASSET__Cmy_ZdmF__"